import React, { Component, PropTypes } from 'react';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import {
  NitroHeading,
  NitroButtonGroup,
  NitroDivider,
  NitroButton,
  NitroPanel,
  NitroPlaceholder
} from 'nitro-components';

import styled from 'styled-components';

import { media } from 'style-utils';

const QuestionWrapper = styled.section`
  min-height: 140px;
`;

const NextButtonWrapper = styled.div`
  margin-left: auto;
  ${media.mobile`margin-left: 0;`};
`;

class QuestionCard extends Component {
  constructor(props) {
    super(props);
    this.state = { selectedAnswer: null };
    this.submitAnswer = this.submitAnswer.bind(this);
  }

  /**
   * componentWillUpdate
   * reset the selected answer to null each time we are viewing a new question
   */
  componentWillUpdate(nextProps) {
    if (nextProps.id !== this.props.id) this.setState({ selectedAnswer: null });
  }

  /**
   * getButtonGroup
   * questions with less than 3 answers are displayed as buttons
   */
  getButtonGroup() {
    const { selectedAnswer } = this.state;
    const { options } = this.props;

    return options.map(option => (
      <NitroButton
        key={option.value}
        label={option.label}
        action={() => this.handleOptionSelect(option.value)}
        width="block"
        block
        size="small"
        leftIcon={selectedAnswer === option.value ? 'success' : undefined}
        insideIconSize={24}
        variant={selectedAnswer === option.value ? 'primary' : null}
      />
    ));
  }

  /**
   * getSelectBox
   * questions with more than 2 answers are displayed in a select box
   */
  getSelectBox() {
    const { selectedAnswer } = this.state;
    const { options, title } = this.props;

    return (
      <div>
        <SelectField
          floatingLabelText={title}
          value={selectedAnswer}
          onChange={(e, i, v) => this.handleOptionSelect(v)}
          style={{ width: '100%' }}
          floatingLabelStyle={{
            marginTop: '-20px'
          }}
        >
          {options.map(o => (
            <MenuItem key={o.value} value={o.value} primaryText={o.label} />
          ))}
        </SelectField>
      </div>
    );
  }

  handleOptionSelect(value) {
    this.setState({ selectedAnswer: value });
  }

  submitAnswer() {
    const { handleResponse, id, name } = this.props;
    const { selectedAnswer } = this.state;

    handleResponse(name, id, selectedAnswer);
  }

  render() {
    const { selectedAnswer } = this.state;
    const { index, title, options, onBack } = this.props;

    return (
      <NitroPanel>
        <NitroPlaceholder size={40} />
        <NitroHeading size="2" align="center" label={title} margin="40" />
        <QuestionWrapper>
          <NitroButtonGroup
            layout="vertical"
            maxWidth={300}
            align="center"
            minHeight={140}
          >
            {options.length > 2 ? this.getSelectBox() : this.getButtonGroup()}
          </NitroButtonGroup>
        </QuestionWrapper>

        <NitroDivider />

        <NitroButtonGroup layout="horizontal">
          {index !== 0 ? (
            <NitroButton size="small" label="Previous" action={onBack} />
          ) : null}
          <NextButtonWrapper>
            <NitroButton
              block
              size="small"
              label="Next"
              variant="primary"
              disabled={!selectedAnswer}
              action={this.submitAnswer}
            />
          </NextButtonWrapper>
        </NitroButtonGroup>
      </NitroPanel>
    );
  }
}

QuestionCard.propTypes = {
  name: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  handleResponse: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired
};

export default QuestionCard;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/components/QuestionCard.js